<h4 class="card-title text-center">National Seminar (2023-24)</h4>
<br>

<h5>Dr. Anurag</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Chaired a session in the ICSSR sponsored Two day National Seminar on March 15-16, 2024 at Indira Gandhi National College, Ladwa.
        </p>
    </li>
</ul>

<h5>Dr. Vinay Kumar</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Shatiyak Chori Aur Copyright Ka Ulanghan</strong> in the National Seminar, Guru Nanak Khalsa College, Yamuna Nagar on December 8-9, 2023.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Mauritius Ke Sandrbh Mein Pravasi Vimarsh</strong> in the one day National Seminar on March 15, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Vijay Sharma</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in National Seminar on the theme <strong>Women And Girls in Science Leadership: A New era for Sustainability</strong> on September 16, 2017, Guru Nanak Khalsa College, Yamuna Nagar.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>World Wetlands Day</strong> on February 2, 2024 hosted by The Dais SDG Lab, IQAC of Guru Nanak Khalsa College, Yamuna Nagar.
        </p>
    </li>
</ul>

<h5>Dr. Gian Bhushan</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024 hosted by The Dais SDG Lab, IQAC & Women Cell of Guru Nanak Khalsa College, Yamuna Nagar.
        </p>
    </li>
</ul>

<h5>Mr. Mohit Kumar</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Forging a fairer society: The Advocacy of Sir Chhotu Ram and Dr. BR Ambedkar for social justice and empowerment</strong> at Two day National Seminar, Indira Gandhi National College, Ladwa on March 15-16, 2024.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Modikaal mein vyakti pooja aur Dr. BR Ambedkar</strong> at Two day National Seminar, DAV College for Girls, Yamuna Nagar on March 15-16, 2024.
        </p>
    </li>
</ul>

<h5>Mr. Dheeraj</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Yoga: Health as a promotional tool</strong> at National Seminar, Guru Nanak Khalsa College, Yamuna Nagar on March 12-13, 2024.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Participated in online two day <strong>Rashtriya Vyakhyan Mala</strong> organized by Deendayal Upadhyay Study Centre, Central University of Himachal Pradesh on the topic <strong>Ekaatm Manav Darshan Evam Aarthik Loktantra</strong> on September 25-26, 2023.
        </p>
    </li>
</ul>

<h5>Ms. Shalini</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Psychological benefit through yoga therapy</strong> at Two day National Seminar, Guru Nanak Khalsa College, Yamuna Nagar on March 12-13, 2024.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024 hosted by The Dais SDG Lab, IQAC & Women Cell of Guru Nanak Khalsa College, Yamuna Nagar.
        </p>
    </li>
</ul>

<h5>Dr. Ramandeep Mahal</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>World Wetlands Day</strong> on February 2, 2024 hosted by The Dais SDG Lab, IQAC of Guru Nanak Khalsa College, Yamuna Nagar.
        </p>
    </li>
</ul>

<h5>Dr. Sunil Kumar Nagra</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>World Wetlands Day</strong> on February 2, 2024.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Presented a paper on <strong>Kudrati Vatavarn Da Hamethi Vikas</strong> in the One day Multidisciplinary International Seminar, Guru Nanak Girls College, Yamuna Nagar on April 10, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Anju Nigam</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Amritpal Singh</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Aditi</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Neelam Behl</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Mr. Jaspreet Singh</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>World Wetlands Day</strong> on February 2, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Mandeep Kaur</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Mr. Etender Singh</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>World Wetlands Day</strong> on February 2, 2024.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Ms. Pratibha Sharma</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Rajesh Kumar Bhardwaj</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Ms. Shalini</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>World Wetlands Day</strong> on February 2, 2024.
        </p>
    </li>
</ul>

<h5>Manju Mandhan</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Yoga: Health as a promotional tool</strong> at National Seminar, Guru Nanak Khalsa College, Yamuna Nagar on March 12-13, 2024.
        </p>
    </li>
</ul>

<h5>Ms. Renu</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Ms. Sonam Saini</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Financing the Startup</strong> at National Seminar, Kurukshetra University, Kurukshetra on October 13, 2023.
        </p>
    </li>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Yoga: Health as a promotional tool</strong> at National Seminar, Guru Nanak Khalsa College, Yamuna Nagar on March 12-13, 2024.
        </p>
    </li>
</ul>

<h5>Dr. Amarjeet Singh</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Presented a paper on the topic <strong>Sports and Physical Education Start-up in India</strong> in One day National Seminar organised by IQAC & NAAC, Govt. College Bhattu Kalan on March 18, 2024.
        </p>
    </li>
</ul>

<h5>Mr. Shivay Sharma</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>

<h5>Ms. Pooja</h5>
<hr>
<ul>
    <li>
        <p class="lead text-justify">
            Participated in Online Seminar celebrating <strong>International Women’s Day</strong> on March 7, 2024.
        </p>
    </li>
</ul>
